export const SocialMediaChannel = {
  FACEBOOK: 'facebook',
}
